// extracted by mini-css-extract-plugin
export var columnList = "_aw-0";